import React from 'react'
import PropTypes from 'prop-types'
import I18n from 'i18n-react'

class Tile extends React.Component {
	static propTypes = {
		active: PropTypes.bool,
		id: PropTypes.string,
		isMoney: PropTypes.bool.isRequired,
		label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		onClick: PropTypes.func,
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
	}

	static defaultProps = {
		active: false,
		id: 0,
		isMoney: false,
		label: '',
		onClick: () => {
		}
	}

	handleOnClick = () => {
		this.props.onClick(this.props.value)
	}

	render() {
		const { active, id, isMoney, label } = this.props

		return (
			<div className='custom-control custom-checkbox checkbox-image with-bg'>
				<input
					checked={active}
					className='custom-control-input'
					id={id}
					name={`${id}-name`}
					onChange={this.handleOnClick}
					type='checkbox'
				/>
				<label className='custom-control-label' htmlFor={id}>
          <span className='image'>
						<span className='label'>
							{isMoney ? (Number(label) / 1000000) + ' mil.' : label}
							{isMoney &&
							<span>{I18n.translate('general.currency')}</span>
							}
						</span>
          </span>
				</label>
			</div>
		)
	}
}

export default Tile
